import React, { useState } from "react";

// Minimal Coming Soon page with ZERO UI library imports (just React + Tailwind classes)
// Drop this in your project and render <ComingSoon />

export default function ComingSoon() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    setError("");

    const valid = /[^@\s]+@[^@\s]+\.[^@\s]+/.test(email);
    if (!valid) {
      setError("Please enter a valid email.");
      return;
    }

    // TODO: Hook up your API (Firebase/Mailchimp/etc.)
    setSubmitted(true);
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-800 text-white relative overflow-hidden flex items-center justify-center p-6">
      {/* Decorative blobs */}
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-indigo-500/20 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-fuchsia-500/20 blur-3xl" />

      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-8">
        <div className="text-center space-y-2">
          <div className="text-4xl">🚀</div>
          <h1 className="text-3xl font-bold tracking-tight">Coming Soon</h1>
          <p className="text-slate-300">
            We’re building something awesome. Stay in the loop!
          </p>
        </div>

        {!submitted ? (
          <form onSubmit={handleSubmit} className="mt-6 grid grid-cols-1 gap-3">
            <label className="text-sm text-slate-300" htmlFor="email">
              Get notified
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-white/10 bg-white/10 px-4 py-3 text-white placeholder-white/60 outline-none focus:ring-2 focus:ring-indigo-400/60"
            />
            {error && <p className="text-sm text-rose-300">{error}</p>}
            <button
              type="submit"
              className="mt-1 rounded-xl px-4 py-3 font-medium bg-white/90 text-slate-900 hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400/80 focus:ring-offset-slate-900 active:scale-[.99] transition"
            >
              Notify Me
            </button>
          </form>
        ) : (
          <p className="mt-6 text-center text-emerald-300">
            🎉 Thanks! You’ll be the first to know.
          </p>
        )}

        <div className="mt-8 flex items-center justify-center gap-5 text-sm text-slate-300">
          <a className="hover:text-white transition" href="/">
            Twitter
          </a>
          <span className="opacity-30">•</span>
          <a className="hover:text-white transition" href="/">
            Instagram
          </a>
          <span className="opacity-30">•</span>
          <a className="hover:text-white transition" href="/">
            LinkedIn
          </a>
          <span className="opacity-30">•</span>
          <a
            className="hover:text-white transition"
            href="mailto:info@example.com"
          >
            Email
          </a>
        </div>
      </div>
    </div>
  );
}
